const store = {namespaced: true};

store.state = {
    profile: {
        email: "",
        first_name: "",
        last_name: "",
        site: null,
        company: null,
        avatar: "",
        passport_number: "",
        passport_number2: "",
        cellphone: "",
        landline: "",
        address: "",
        city: "",
        country: null,
        emergency_contact_first_name: "",
        emergency_contact_last_name: "",
        emergency_contact_relationship: "",
        emergency_contact_email: "",
        emergency_contact_cellphone: "",
        emergency_contact_landline: "",
        account_type: 1,
        account_privilege: "",
        last_login: null,
        updated: null,
        created: null,
    },
    selectedCompany: null

};

store.mutations = {
    'SET_USER_PROFILE'(state, data) {
        state.profile = data;
    },

};

store.actions = {
    setUserProfile({commit}, data) {
        commit('SET_USER_PROFILE', data);
    }
};

store.getters = {};


export default store
